/**
 * Represents the type of notification to use
 */
export enum NotificationType {
    Error = "ERROR",
    Success = "SUCCESS",
    Warning = "WARNING"
}
